export const isDevBypassAuthEnabled = process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_BYPASS_AUTH === 'true'

export const DEV_AUTH_TOKEN = 'dev-local-bypass-token'

export const devAuthPayload = {
  status: true,
  message: 'Local dev login (API calls still need real server credentials).',
  token: DEV_AUTH_TOKEN,
  user: {
    email: 'dev@local',
    name: 'Local Dev',
  },
}
